import React, {useEffect, useState} from 'react';
import {Container, Row, Col, Card, Modal} from 'react-bootstrap';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper/modules';


import {getProducer} from "../api/ProfileAPIs";

import Loading from "../../../layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../../layouts/Header";
import {MdOutlineBookmark} from "react-icons/md";

const currencyFormat = Intl.NumberFormat('en-US');
// فرض می‌شود این تابع به صورت گلوبال در دسترس است
// declare function showWarning(message: string): void;

function ProducersAllProduct() {
    const {id} = useParams();
    const [producer, setProducer] = useState([]);
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducers = async () => {

            const params = {

                perPage : 100
            };


            try {
                const data = await getProducer(id,params);
                setProducer(data?.data || []);
            } catch (error) {
                console.error("Failed to fetch producers:", error);
                setProducer([]);
            } finally {
                setLoading(false);
            }
        };
        fetchProducers();

    }, []);






    if (loading) return <Loading />;

    return (
        <Container className="producer-detail-page py-4 mt-5">
            <Header hasBack={true} transparent={false} title='مشاهده همه محصولات تولید کننده'/>
            {/* 1. Header Section */}
            <Card className="section-card p-3 mb-4">
                <Row className="align-items-center producer-header">
                    <Col xs="auto">
                        <img src={producer.image} alt={producer.name} className="producer-image rounded-circle"/>
                    </Col>
                    <Col>
                        <h4 className="fw-bold mb-1">{producer.name}</h4>
                        <p className="text-muted mb-3 text-small-3 text-justify">{producer.brief}</p>
                    </Col>
                </Row>
            </Card>

            <div className="row ms-3 me-2 pb-5 mb-3">


                {
                    !loading && producer.products.map((product, index) => {

                        return (

                            <div className="col-6 col-md-3 px-0 mt-0"

                                 key={product.id}
                            >
                                <div className="row vendor-product m-1">
                                    <div className="col-12 text-center mt-3"
                                         onClick={
                                             () => {
                                                 navigate(`/product/${product.id}`)

                                             }
                                         }
                                    >
                                        {
                                            product.vendor_price?.discount_percent > 0 &&
                                            <div className='discount-percent'>
                                                    <span
                                                        className='badge badge-info badge-pill bg-primary-color  text-small-3'>
                                                    {product?.vendor_price?.discount_percent}
                                                        &nbsp;

                                                        %

                                                </span>
                                            </div>
                                        }
                                        {
                                            product.is_favorite > 0 ?
                                                <MdOutlineBookmark
                                                    className='me-3  text-big-4 text-third-color float-start'

                                                />
                                                :
                                                ''
                                        }
                                        <div className="clearfix"></div>
                                        <img src={product.image} alt={product.name}/>

                                    </div>
                                    <div className="col-12 text-center text-small-2" onClick={
                                        () => {
                                            navigate(`/product/${product.id}`)
                                        }
                                    }>
                                        {product.name.substring(0, 30)}
                                    </div>

                                    <div className="col-12 ">
                                        {product.vendor_price?.price ?
                                            <div className=" text-start mt-4 mb-2 text-muted fw-bold text-small-1">

                                                {
                                                    product.vendor_price?.discount_percent > 0 ?
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50 '>
                                                            {currencyFormat.format(product.vendor_price?.price)}
                                                            &nbsp;
                                                            {config.currency}
                                                        </div> :
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50'>
                                                            &nbsp;
                                                        </div>

                                                }

                                                <div>
                                                    {currencyFormat.format(product.vendor_price?.discounted_price)}
                                                    &nbsp;
                                                    <span className='text-small-3 text-muted'>
                                                            {config.currency}
                                                    </span>
                                                </div>


                                            </div>
                                            : ''
                                        }
                                    </div>



                                </div>
                            </div>
                        )
                    })
                }
            </div>



        </Container>
    );
}

export default ProducersAllProduct;
